import { render, staticRenderFns } from "./Lgx266206682504232960.vue?vue&type=template&id=5944e48a&"
import script from "./Lgx266206682504232960.vue?vue&type=script&lang=js&"
export * from "./Lgx266206682504232960.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports